<p>base-section-edit works!</p>
